import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaFileMedical, FaHeartbeat, FaUserInjured, FaHospital, 
         FaStethoscope, FaChartLine, FaFlask, FaSearch, FaMicroscope } from 'react-icons/fa';
import Layout from './layout';
import { useAuth } from './context/AuthContext';
import axios from 'axios';
import Navbar from './Navbar';
import DoctorNavbar from './DocNav';
import DoctorScheduleManager from './Schedule';
import { appointmentService } from './AppointmentsService';
import VitalsUpdateModal from './VitalsUpdateModal';
import { doctorService } from './DoctorsService';


const Dashboard = () => {
    const { currentUser } = useAuth();
    const userName = currentUser?.firstName || 'User'; // Use firstName from user data
    const [appointments, setAppointments] = useState([]);
    const [consultations, setConsultations] = useState([]);
    const [patientCount, setPatientCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [testResults, setTestResults] = useState([]);
    const [doctorDetails, setDoctorDetails] = useState([]);
const [showVitalsModal, setShowVitalsModal] = useState(false);
const [vitals, setVitals] = useState({
    bloodPressure: { value: '120/80', updatedAt: '2025-03-04', status: 'normal' },
    heartRate: { value: '78', updatedAt: '2025-03-04', status: 'normal' },
    temperature: { value: '98.6', updatedAt: '2025-03-04', status: 'normal' },
    oxygenSaturation: { value: '98', updatedAt: '2025-03-04', status: 'normal' },
    weight: { value: '154', updatedAt: '2025-02-28', status: 'normal' },
    bloodGlucose: { value: '110', updatedAt: '2025-03-02', status: 'borderline' }
});
// Add this helper function in your component
const formatRelativeDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} week${Math.floor(diffDays / 7) > 1 ? 's' : ''} ago`;
    return `${Math.floor(diffDays / 30)} month${Math.floor(diffDays / 30) > 1 ? 's' : ''} ago`;
  };
  // Add this useEffect to load saved vitals from localStorage when component mounts
useEffect(() => {
    // Try to load saved vitals from localStorage
    const savedVitals = localStorage.getItem('patientVitals');
    if (savedVitals) {
      try {
        const parsedVitals = JSON.parse(savedVitals);
        setVitals(parsedVitals);
      } catch (error) {
        console.error('Error parsing saved vitals:', error);
        // If there's an error parsing, we'll just use the default values
      }
    }
  }, []);
    // useEffect(() => {
    //     // Simulate setting the current user role to 'patient'
    //     setCurrentUser({ name: 'John Doe', role: 'doctor' });
    // }, []);
    useEffect(() => {
        const fetchDashboardData = async () => {
            setLoading(true);
            try {
                // Fetch real appointment data based on user role
                let realAppointments = [];
                if (currentUser.role === 'patient') {
                    realAppointments = await appointmentService.getAppointmentsByUser(currentUser._id);
                }  else if (currentUser.role === 'doctor') {
                  // Fetch doctor-specific details if user is a doctor
                  try {
                      const doctorData = await doctorService.getDoctorById(currentUser._id);
                      setDoctorDetails(doctorData);
                      console.log('Doctor details:', doctorData);
                  } catch (error) {
                      console.error("Error fetching doctor details:", error);
                  }
                  
                  realAppointments = await appointmentService.getAppointmentsByDoctor(currentUser._id);
                  console.log('Doctor appointments:', realAppointments);
              }
                
                // Format appointments for display
                const formattedAppointments = realAppointments.map(apt => ({
                    id: apt._id,
                    doctorName: apt.doctorName || `Dr. ${apt.doctorId?.lastName || 'Unknown'}`,
                    patientName: apt.patientName || apt.patient?.firstName + ' ' + apt.patient?.lastName || 'Unknown Patient',
                    date: apt.startTime || apt.date,
                    time: new Date(apt.startTime || apt.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    status: apt.status || 'Scheduled',
                    reason: apt.title || apt.reason || 'Consultation'
                }));
                console.log('realAppointments:', realAppointments);
                
                // Sort by date (most recent first)
                formattedAppointments.sort((a, b) => new Date(a.date) - new Date(b.date));
                
                setAppointments(formattedAppointments);
    
                // The rest of your dummy data can be kept for now
                const dummyConsultations = [
                    { id: 1, doctorName: 'Dr. Smith', date: '2023-09-20', diagnosis: 'Flu' },
                    { id: 2, doctorName: 'Dr. Johnson', date: '2023-09-25', diagnosis: 'Cold' }
                ];
                const dummyTestResults = [
                    { id: 1, testName: 'Blood Test', date: '2023-09-15', status: 'Normal' },
                    { id: 2, testName: 'X-Ray', date: '2023-09-18', status: 'Normal' }
                ];
                const dummyPatientCount = 25;
    
                setConsultations(dummyConsultations);
                setTestResults(dummyTestResults);
                
                if (currentUser.role === 'doctor') {
               // Get unique patient IDs from appointments
 // Replace the problematic patient counting code with this improved version

// Get unique patient IDs from appointments
const uniquePatientIds = new Set();

realAppointments.forEach(apt => {
  // Extract patientId using various possible structures
  let patientId = null;
  
  // Check all possible locations for patient ID
  if (apt.patientId && typeof apt.patientId === 'string') {
    patientId = apt.patientId;
  } else if (apt.patientId && apt.patientId._id) {
    patientId = apt.patientId._id;
  } else if (apt.patient && apt.patient._id) {
    patientId = apt.patient._id;
  } else if (apt.patient && apt.patient.id) {
    patientId = apt.patient.id;
  }
  
  // If we found an ID, add it to our unique set
  if (patientId) {
    uniquePatientIds.add(patientId);
  }
});

console.log('Unique patient count:', uniquePatientIds.size);
setPatientCount(uniquePatientIds.size);
}
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            } finally {
                setLoading(false);
            }
        };
    
        if (currentUser) {
            fetchDashboardData();
        }
    }, [currentUser]);

    // Conditional rendering based on role
    const renderDashboard = () => {
        if (loading) {
            return (
                <div className="flex items-center justify-center h-64">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
                </div>
            );
        }

        if (currentUser.role === 'patient') {
            return renderPatientDashboard();
        } else if (currentUser.role === 'doctor') {
            return renderDoctorDashboard();
        }

        return <p>Unknown user role.</p>;
    };

    const renderPatientDashboard = () => {
        return (
            <>
            <Navbar />
            <div className="grid grid-cols-1 px-5 md:px-20 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
                {/* Upcoming Appointments */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
    <h2 className="text-2xl font-semibold mb-4 flex items-center">
        <FaCalendarAlt className="mr-2 text-blue-600" />
        Upcoming Appointments
    </h2>
    {appointments.length > 0 ? (
        <div>
            {appointments.slice(0, 3).map((appointment) => (
                <div key={appointment.id} className="mb-3 p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="font-medium">{appointment.doctorName}</p>
                            <p className="text-sm text-gray-600">
                                {new Date(appointment.date).toLocaleDateString('en-US', { 
                                    weekday: 'short',
                                    month: 'short', 
                                    day: 'numeric' 
                                })} at {appointment.time}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">{appointment.reason}</p>
                        </div>
                        <span className={`text-xs px-2 py-1 rounded-full 
                            ${appointment.status === 'Completed' ? 'bg-green-100 text-green-800' : 
                              appointment.status === 'Cancelled' ? 'bg-red-100 text-red-800' : 
                              'bg-blue-100 text-blue-800'}`}>
                            {appointment.status}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    ) : (
        <div className="text-center py-6">
            <div className="text-gray-400 mb-2">
                <FaCalendarAlt className="mx-auto text-3xl" />
            </div>
            <p className="text-gray-600">No upcoming appointments scheduled.</p>
            <Link to="/appointments" className="mt-3 inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                Book an Appointment
            </Link>
        </div>
    )}
    <Link to="/appointments" className="text-blue-600 hover:underline mt-3 inline-block">View All Appointments</Link>
</div>

                {/* Recent Test Results */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h2 className="text-2xl font-semibold mb-4 flex items-center">
                        <FaFlask className="mr-2 text-blue-600" />
                        Recent Test Results
                    </h2>
                    {testResults.length > 0 ? (
                        <div>
                            {testResults.slice(0, 3).map((test) => (
                                <div key={test.id} className="mb-3 p-3 bg-gray-50 rounded">
                                    <p className="font-medium">{test.testName}</p>
                                    <p className="text-sm text-gray-600">{new Date(test.date).toLocaleDateString()}</p>
                                    <p className="text-sm">{test.status}</p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No recent test results available.</p>
                    )}
                    <Link to="/test-results" className="text-blue-600 hover:underline mt-2 inline-block">View All</Link>
                </div>

                {/* Symptom Analysis Tool */}
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h2 className="text-2xl font-semibold mb-4 flex items-center">
                        <FaSearch className="mr-2 text-blue-600" />
                        Symptom Analysis
                    </h2>
                    <p>Our AI-powered symptom analyzer can help identify potential health issues.</p>
                    <div className="mt-4 bg-blue-50 p-4 rounded-lg">
                        <p className="text-sm mb-2">Enter your symptoms to get instant health insights</p>
                        <Link to="/predictions" className="inline-block w-full py-2 px-4 bg-blue-600 text-white font-medium text-center rounded-md hover:bg-blue-700 transition-colors">
                            Start Analysis
                        </Link>
                    </div>
                </div>

          {/* Recent Doctors Consultations - Enhanced */}
<div className="bg-white p-6 rounded-lg h-fit shadow-lg">
    <h2 className="text-2xl font-semibold mb-4 flex items-center">
        <FaFileMedical className="mr-2 text-blue-600" />
        Recent Doctor Consultations
    </h2>
    
    {appointments.length > 0 ? (
        <div className="space-y-3">
            {appointments
    .filter(apt => {
        // Check if appointment date is in the past
        const appointmentDate = new Date(apt.endTime);
        const currentDate = new Date();
        return appointmentDate < currentDate || apt.status === 'Completed';
    })
                .slice(0, 3)
                .map((appointment) => (
                    <div key={appointment.id} className="p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors border-l-3 border-blue-500">
                        <div className="flex items-center">
                            <div className="bg-blue-100 rounded-full p-2 mr-3">
                                <FaStethoscope className="text-blue-600" />
                            </div>
                            <div className="flex-grow">
                                <p className="font-medium text-gray-800">{appointment.doctorName}</p>
                                <p className="text-xs text-gray-500">
                                    {appointment.reason} • {new Date(appointment.date).toLocaleDateString('en-US', { 
                                        month: 'short', 
                                        day: 'numeric',
                                        year: 'numeric'
                                    })}
                                </p>
                            </div>
                            <button 
                                onClick={() => window.location.href = `/appointments`}
                                className="text-xs px-3 py-1.5 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors"
                            >
                                Book Follow-up
                            </button>
                        </div>
                    </div>
                ))}
        </div>
    ) : (
        <div className="text-center py-6">
            <div className="text-gray-400 mb-3">
                <FaFileMedical className="mx-auto text-3xl" />
            </div>
            <p className="text-gray-600 mb-2">You haven't had any consultations yet.</p>
            <Link to="/appointments" className="mt-2 inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                Find a Doctor
            </Link>
        </div>
    )}
    
    {/* <div className="mt-4 pt-3 border-t border-gray-100 flex justify-between items-center">
        <Link to="/health-records" className="text-blue-600 hover:underline inline-flex items-center">
            View All Consultations
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
        </Link>
        
        <Link to="/appointments" className="text-blue-600 hover:underline inline-flex items-center">
            Browse Doctors
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
        </Link>
    </div> */}
</div>
{/* Health Insights - Dynamic version */}
<div className="bg-white p-6 rounded-lg shadow-lg">
    <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold flex items-center">
            <FaChartLine className="mr-2 text-blue-600" />
            Health Insights
        </h2>
        <button 
            onClick={() => setShowVitalsModal(true)}
            className="px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors flex items-center"
        >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Update Vitals
        </button>
    </div>
    
    <div className="mb-4">
        <h3 className="font-medium mb-2 text-gray-700">Recent Vitals</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {/* Blood Pressure */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Blood Pressure</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.bloodPressure.status === 'normal' ? 'bg-green-500' : 
                        vitals.bloodPressure.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.bloodPressure.status.charAt(0).toUpperCase() + vitals.bloodPressure.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.bloodPressure.value}</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.bloodPressure.updatedAt)}</p>
            </div>
            
            {/* Heart Rate */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Heart Rate</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.heartRate.status === 'normal' ? 'bg-green-500' : 
                        vitals.heartRate.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.heartRate.status.charAt(0).toUpperCase() + vitals.heartRate.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.heartRate.value} bpm</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.heartRate.updatedAt)}</p>
            </div>
            
            {/* Temperature */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Temperature</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.temperature.status === 'normal' ? 'bg-green-500' : 
                        vitals.temperature.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.temperature.status.charAt(0).toUpperCase() + vitals.temperature.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.temperature.value} °F</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.temperature.updatedAt)}</p>
            </div>
            
            {/* Oxygen Saturation */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Oxygen Saturation</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.oxygenSaturation.status === 'normal' ? 'bg-green-500' : 
                        vitals.oxygenSaturation.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.oxygenSaturation.status.charAt(0).toUpperCase() + vitals.oxygenSaturation.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.oxygenSaturation.value}%</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.oxygenSaturation.updatedAt)}</p>
            </div>
            
            {/* Weight */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Weight</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.weight.status === 'normal' ? 'bg-green-500' : 
                        vitals.weight.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.weight.status.charAt(0).toUpperCase() + vitals.weight.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.weight.value} lbs</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.weight.updatedAt)}</p>
            </div>
            
            {/* Blood Glucose */}
            <div className="bg-blue-50 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                    <p className="text-xs text-gray-600">Blood Glucose</p>
                    <span className={`h-2 w-2 rounded-full ${
                        vitals.bloodGlucose.status === 'normal' ? 'bg-green-500' : 
                        vitals.bloodGlucose.status === 'borderline' ? 'bg-yellow-500' : 'bg-red-500'
                    }`} title={vitals.bloodGlucose.status.charAt(0).toUpperCase() + vitals.bloodGlucose.status.slice(1)}></span>
                </div>
                <p className="font-medium text-lg text-gray-800 mt-1">{vitals.bloodGlucose.value} mg/dL</p>
                <p className="text-xs text-gray-500">Last updated: {formatRelativeDate(vitals.bloodGlucose.updatedAt)}</p>
            </div>
        </div>
    </div>
    
    <div className="flex justify-between items-center">
        <Link to="/health-trends" className="text-blue-600 hover:underline inline-block flex items-center">
            View Health Trends
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
        </Link>
        
        <div className="flex items-center">
            <span className="h-2 w-2 rounded-full bg-green-500 mr-1"></span>
            <span className="text-xs text-gray-500 mr-2">Normal</span>
            
            <span className="h-2 w-2 rounded-full bg-yellow-500 mr-1"></span>
            <span className="text-xs text-gray-500 mr-2">Borderline</span>
            
            <span className="h-2 w-2 rounded-full bg-red-500 mr-1"></span>
            <span className="text-xs text-gray-500">Alert</span>
        </div>
    </div>
</div>

                {/* Personalized Recommendations */}
                {/* <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h2 className="text-2xl font-semibold mb-4 flex items-center">
                        <FaHeartbeat className="mr-2 text-blue-600" />
                        Personalized Recommendations
                    </h2>
                    <p>Based on your health data, here are some recommendations:</p>
                    <ul className="list-disc ml-5 mt-2">
                        <li>Regular check-ups</li>
                        <li>Balanced diet and exercise</li>
                        <li>Follow up on previous treatments</li>
                    </ul>
                    <Link to="/health-analysis" className="text-blue-600 hover:underline mt-3 inline-block">Get Analysis</Link>
                </div> */}
            </div>
            </>
        );
    };

    const renderDoctorDashboard = () => {
        return (
          <>
            <DoctorNavbar />
            <div className="grid grid-cols-1 px-4 md:px-12 lg:px-20 md:grid-cols-2 lg:grid-cols-2 gap-6">
              {/* Today's Appointments - Enhanced styling */}
              <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
                <h2 className="text-2xl font-semibold mb-4 flex items-center text-gray-800">
                  <FaCalendarAlt className="mr-3 text-blue-600" />
                  Today's Appointments
                </h2>
                
                {appointments.length > 0 ? (
                  <div className="space-y-3">
                    {appointments.slice(0, 4).map((appointment) => (
                      <div 
                        key={appointment.id} 
                        className="p-4 bg-gray-50 rounded-lg border-l-4 border-blue-500 hover:bg-blue-50 transition-colors"
                      >
                        <div className="flex justify-between items-start">
                          <div>
                            <p className="font-semibold text-gray-800">{appointment.patientName}</p>
                            <div className="flex items-center text-sm text-gray-600 mt-1">
                              <span className="inline-block w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
                              {appointment.time}
                            </div>
                            <p className="text-sm text-gray-600 mt-1">{appointment.reason}</p>
                          </div>
                          <span className={`text-xs px-3 py-1 rounded-full font-medium
                            ${appointment.status === 'Completed' ? 'bg-green-100 text-green-800' : 
                              appointment.status === 'Cancelled' ? 'bg-red-100 text-red-800' : 
                              'bg-blue-100 text-blue-800'}`}
                          >
                            {appointment.status}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8 bg-gray-50 rounded-lg">
                    <div className="text-gray-400 mb-3">
                      <FaCalendarAlt className="mx-auto text-4xl opacity-50" />
                    </div>
                    <p className="text-gray-600 mb-2">No appointments scheduled for today.</p>
                    <Link to="/appointments" className="text-blue-600 hover:text-blue-700 font-medium">
                      View your schedule
                    </Link>
                  </div>
                )}
                
                <div className="flex justify-between items-center mt-5 pt-4 border-t border-gray-100">
                  <Link to="/appointments" className="text-blue-600 hover:text-blue-800 transition-colors flex items-center font-medium">
                    View All
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                  
                  <Link to="/appointments" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium">
                    Add Appointment
                  </Link>
                </div>
              </div>
      
              {/* Patient Management - Enhanced styling */}
          {/* Patient Management - Enhanced with real patient metrics */}
{/* Patient Management - Enhanced with patient details */}
<div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
  <h2 className="text-2xl font-semibold mb-4 flex items-center text-gray-800">
    <FaUserInjured className="mr-3 text-blue-600" />
    Patient Management
  </h2>
  
  <div className="bg-blue-50 p-4 rounded-lg mb-4 flex items-center">
    <div className="bg-blue-100 rounded-full p-3 mr-4">
      <FaUserInjured className="text-blue-600 text-xl" />
    </div>
    <div className="flex-grow">
      <p className="text-gray-700">You currently have</p>
      <div className="flex items-center">
        <p className="text-2xl font-bold text-blue-800">{patientCount} patients</p>
        {patientCount > 0 && (
          <span className="ml-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full flex items-center">
            Active
          </span>
        )}
      </div>
      <p className="text-gray-700">under your care</p>
    </div>
  </div> 
  
  {/* Recent patients list */}
  {appointments.length > 0 && (
    <div className="mb-4">
      <h3 className="text-sm font-medium text-gray-700 mb-2">Recent patients</h3>
      <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
        {/* Get unique patients from appointments */}
        {Array.from(new Set(appointments.map(apt => apt.patientName)))
          .slice(0, 4)
          .map((patientName, index) => {
            // Find the appointment for this patient
            const patientAppointment = appointments.find(apt => apt.patientName === patientName);
            return (
              <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded-lg hover:bg-gray-100">
                <div className="flex items-center">
                  <div className="bg-blue-100 h-8 w-8 rounded-full flex items-center justify-center mr-2">
                    <span className="text-blue-600 font-medium text-sm">
                      {patientName.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium">{patientName}</p>
                    <p className="text-xs text-gray-500">
                      Last visit: {new Date(patientAppointment.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <Link 
                  to={`/patients/details/${patientAppointment.patientId || 'unknown'}`} 
                  className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
                >
                  View Details
                </Link>
              </div>
            );
        })}
      </div>
    </div>
  )}

  {/* Patient categories */}
  <div className="grid grid-cols-2 gap-2 mb-4">
    <div className="bg-gray-50 p-2 rounded-lg text-center">
      <p className="text-xs text-gray-500">New Patients</p>
      <p className="font-medium text-gray-800">{patientCount}</p>
    </div>
    <div className="bg-gray-50 p-2 rounded-lg text-center">
      <p className="text-xs text-gray-500">Regular Patients</p>
      <p className="font-medium text-gray-800">{patientCount}</p>
    </div>
  </div>
  
  <div className="grid grid-cols-2 gap-4 mt-4">
    <Link to="/patients" className="bg-gray-50 p-4 rounded-lg text-center hover:bg-gray-100 transition-colors group">
      <div className="bg-white rounded-full h-10 w-10 flex items-center justify-center mx-auto mb-2 group-hover:bg-blue-50 transition-colors">
        <FaHospital className="text-blue-600 text-lg" />
      </div>
      <span className="font-medium text-gray-800">View All Patients</span>
    </Link>
    <Link to="/patients/new" className="bg-gray-50 p-4 rounded-lg text-center hover:bg-gray-100 transition-colors group">
      <div className="bg-white rounded-full h-10 w-10 flex items-center justify-center mx-auto mb-2 group-hover:bg-blue-50 transition-colors">
        <FaUserInjured className="text-blue-600 text-lg" />
      </div>
      <span className="font-medium text-gray-800">Add Patient</span>
    </Link>
  </div>
</div>
      
              {/* Doctor Schedule - Enhanced wrapper for schedule component */}
              <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
                <h2 className="text-2xl font-semibold mb-4 flex items-center text-gray-800">
                  <FaCalendarAlt className="mr-3 text-blue-600" />
                  My Schedule
                </h2>
                <DoctorScheduleManager />
              </div>
      
              {/* Clinical Tools - Enhanced styling */}
              <div className="bg-white h-fit p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
                <h2 className="text-2xl font-semibold mb-4 flex items-center text-gray-800">
                  <FaMicroscope className="mr-3 text-blue-600" />
                  Clinical Tools
                </h2>
                
                <div className="grid grid-cols-2 gap-4">
                  <Link to="/disease-detection" className="group">
                    <div className="bg-gray-50 p-5 rounded-lg text-center hover:bg-blue-50 transition-colors h-full flex flex-col items-center justify-center">
                      <div className="bg-white rounded-full h-14 w-14 flex items-center justify-center mx-auto mb-3 shadow-sm group-hover:bg-blue-100 group-hover:shadow-md transition-all">
                        <FaMicroscope className="text-blue-600 text-xl" />
                      </div>
                      <span className="font-medium text-gray-800 group-hover:text-blue-700 transition-colors">Pneumonia Detection</span>
                      <p className="text-xs text-gray-500 mt-1">AI-powered diagnosis</p>
                    </div>
                  </Link>
                  <Link to="/predictions" className="group">
                    <div className="bg-gray-50 p-5 rounded-lg text-center hover:bg-blue-50 transition-colors h-full flex flex-col items-center justify-center">
                      <div className="bg-white rounded-full h-14 w-14 flex items-center justify-center mx-auto mb-3 shadow-sm group-hover:bg-blue-100 group-hover:shadow-md transition-all">
                        <FaSearch className="text-blue-600 text-xl" />
                      </div>
                      <span className="font-medium text-gray-800 group-hover:text-blue-700 transition-colors">Symptom Analysis</span>
                      <p className="text-xs text-gray-500 mt-1">Process patient symptoms</p>
                    </div>
                  </Link>
                </div>
                
                <div className="mt-5 pt-4 border-t border-gray-100">
                  <Link to="/clinical-tools" className="text-blue-600 hover:text-blue-800 transition-colors flex items-center justify-center font-medium">
                    View All Clinical Tools
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </>
        );
      };
     


    return (
        <div className='min-h-full  my-auto'>
           
           <div className="min-h-full py-32">
                <h1 className="text-4xl px-20 font-bold mb-6">
                Welcome, {currentUser ? `${currentUser.firstName} ${currentUser.lastName}` : 'User'}!
                {/* {doctorDetails && currentUser.role === 'doctor' && (
                    <span className="block text-lg font-normal text-gray-600 mt-10">
                        {doctorDetails.specialty || 'General Practitioner'}
                    </span>
                )} */}
                </h1>
                {renderDashboard()}
            </div>
                <VitalsUpdateModal 
  isOpen={showVitalsModal}
  onClose={() => setShowVitalsModal(false)}
  currentVitals={vitals}
  onSave={(updatedVitals) => {
    setVitals(updatedVitals);
    localStorage.setItem('patientVitals', JSON.stringify(updatedVitals));
    // Here you would also save the vitals to your backend
  }}
/>

          
        </div>
    );
    
};

export default Dashboard;